<template>
  <div>
    <!-- TAB -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              TABS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row class="mt-4">
              <div class="col-3">
                <h2>
                  Default
                </h2>
                <b-tabs>
                  <b-tab title="YAYINDAKİLER (3)"
                         title-link-class="deactive"
                  />
                </b-tabs>
              </div>
              <div class="col-3">
                <h2>
                  Selected [purple]
                </h2>
                <b-tabs>
                  <b-tab title="YAYINDAKİLER (3)" />
                </b-tabs>
              </div>
              <div class="col-3">
                <h2>
                  Selected
                </h2>
                <b-tabs>
                  <b-tab title="YAYINDAKİLER (3)"
                         title-link-class="black"
                  />
                </b-tabs>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <p>
                  Örnek kullanımlar;
                </p>
                <div class="bg-white mt-2">
                  <b-tabs>
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                  </b-tabs>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <div class="tab-with-title">
                  <h1>
                    Page Title
                  </h1>
                  <b-tabs>
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                  </b-tabs>
                </div>
              </div>
            </b-row>

            <b-row class="mt-4">
              <div class="col-10">
                <div class="tab-with-title">
                  <h1>
                    Page Title
                  </h1>
                  <b-tabs class="center">
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                    <b-tab title="YAYINDAKİLER (3)" />
                  </b-tabs>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <h1 class="pb-1">
                  For Nav Bar
                </h1>
                <div class="tab-with-title">
                  <h1>
                    Hesabım
                  </h1>
                  <b-nav class="sub-nav">
                    <b-nav-item class="black"
                                :to="{name:'MyCompanyView'}"
                    >
                      Şirket Bilgilerim
                    </b-nav-item>
                    <b-nav-item class="black"
                                :to="{name:'CompanyProfilesView'}"
                    >
                      Şirket Profilim
                    </b-nav-item>
                    <b-nav-item class="black"
                                :to="{name:'MyProductsView'}"
                    >
                      Üyelik Haklarım
                    </b-nav-item>
                    <b-nav-item class="black"
                                :to="{name:'MyCustomerCareView'}"
                    >
                      Müşteri Temsilcisi
                    </b-nav-item>
                  </b-nav>
                </div>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <div class="tab-with-title pb-3">
                  <h1>
                    Page Title
                  </h1>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Tab',
  data() {
    return {};
  },
  computed: {},
};
</script>
